'use strict';

const Mn = require('backbone.marionette');
const NavView = require('balus/ui/view/body/role-dashboard/nav/index');
const ContentView = require('balus/ui/view/body/group-role/content/index');
const TitleView = require('balus/ui/view/body/group-role/title');
const CoverView = require('balus/ui/view/body/group/cover');
const Template = require('balus/ui/template/body/group-role/index.hbs');
// const ToolbarView = require('balus/ui/view/body/group/toolbar/index');

module.exports = Mn.View.extend({
    className: 'row',
    template: Template,
    regions: {
        cover: '#cover',
        title: '#title',
        nav: '#nav',
        toolbar: '#toolbar',
        content: '#content',
    },

    onRender: function() {
        const group = this.getOption('group');

        this.showChildView('cover', new CoverView({
            model: group,
            roles: true
        }));
        this.showChildView('nav', new NavView({
            model: group,
            groupRole: this.model,
            user: this.getOption('user')
        }));
        this.showChildView('title', new TitleView({
            model: this.model
        }));
        this.showChildView('content', new ContentView({
            model: this.model
        }));
    //
    //     let navs = new SidebarCollection(
    //         [
    //             {
    //                 name: 'members',
    //                 open: true,
    //                 icon: 'fa fa-users',
    //                 label: 'module/word:groupMember',
    //                 view: new MemberListView({
    //                     model: this.model,
    //                     collection: this.model.getMembers({withSuspended: true})
    //                 })
    //             }
    //         ]
    //     );
    //
    //     if(this.model.get('isAdmin')) {
    //         navs.push({
    //             name: 'invitations',
    //             icon: 'fa fa-envelope',
    //             label: 'module/word:invitation',
    //             view: new InvitationListView({
    //                 model: this.model
    //             })
    //         });
    //     }
    //     this.showChildView('sidebar', new SidebarView({
    //         navs: navs,
    //         horizontalNav: true
    //     }));
    //     this.showChildView('toolbar', new ToolbarView({
    //         model: this.model,
    //         user: this.getOption('user')
    //     }));
    //     this.getChildView('toolbar').renderNav(navs);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group-role/index.js